import { PeerMessage, PeerMessageType } from '@playcastdotio/Messaging';
import { hostConnectionState } from '../../stores';
import { getPeer } from '../..';

export const handlePeerMessage = (message: PeerMessage) => {
  switch (message.type) {
    case PeerMessageType.PEER_GET_ID_ANSWER: {
      hostConnectionState.updateState({
        ...hostConnectionState.currentState,
        playerPeerId: message.peerId,
        iceServers: message.iceServers || undefined,
      });
      break;
    }
    case PeerMessageType.PEER_ICE_CANDIDATE:
    case PeerMessageType.PEER_SDP_ANSWER:
    case PeerMessageType.PEER_SDP_OFFER: {
      const peer = getPeer();
      if (peer) {
        peer.handlePeerMessage(message);
      }
      break;
    }
  }
};
